<template>
	<div class="flex fd-c g-sm">
		<o-alert :color="setup.attachmentAlert.color">
			{{ setup.attachmentAlert.label }}
		</o-alert>

		<template v-if="comment">
			<o-alert
				class="formatted-text"
				title="Votre commentaire"
				color="default">
				{{ comment }}
			</o-alert>
		</template>

		<div class="pa-xs">
			<p>Confirmez-vous la <strong>validation</strong> de ce relevé ?</p>
			<p>Il ne pourra <strong>plus être modifié</strong> et vous retrouverez l'historique dans le détail du contrat.</p>
		</div>
	</div>
</template>

<script setup lang="ts">
import TimeTicketWeekConfirmModalSetupService from '@/setup/time-ticket/TimeTicketWeekConfirmModalSetupService';
const props = defineProps(TimeTicketWeekConfirmModalSetupService.props);
const setup = new TimeTicketWeekConfirmModalSetupService(props);
</script>
